function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
/** @jsx jsx */
import Button from '@datacamp/waffles-button';
import { css, jsx } from '@emotion/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { jsx as ___EmotionJSX } from "@emotion/react";
var _ref = "production" === "production" ? {
  name: "px8pbp",
  styles: "width:90px"
} : {
  name: "1ihz68x-HintButton",
  styles: "width:90px;label:HintButton;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0V4ZXJjaXNlL0NvbnZlcnNhdGlvbmFsSW50ZXJmYWNlTGF5b3V0L0hpbnRCdXR0b24udHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXFCYyIsImZpbGUiOiIuLi8uLi8uLi8uLi9zcmMvY29tcG9uZW50cy9FeGVyY2lzZS9Db252ZXJzYXRpb25hbEludGVyZmFjZUxheW91dC9IaW50QnV0dG9uLnRzeCIsInNvdXJjZXNDb250ZW50IjpbIi8qKiBAanN4IGpzeCAqL1xuaW1wb3J0IEJ1dHRvbiBmcm9tICdAZGF0YWNhbXAvd2FmZmxlcy1idXR0b24nO1xuaW1wb3J0IHsgY3NzLCBqc3ggfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5pbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsgdXNlVHJhbnNsYXRpb24gfSBmcm9tICdyZWFjdC1pMThuZXh0JztcblxudHlwZSBIaW50QnV0dG9uUHJvcHMgPSB7XG4gIGRhdGFMYWJlbDogc3RyaW5nO1xuICBvbkNsaWNrOiAoKSA9PiB2b2lkO1xufTtcblxuZXhwb3J0IGNvbnN0IEhpbnRCdXR0b246IFJlYWN0LkZDPEhpbnRCdXR0b25Qcm9wcz4gPSAoe1xuICBkYXRhTGFiZWwsXG4gIG9uQ2xpY2ssXG59KSA9PiB7XG4gIGNvbnN0IHsgdCB9ID0gdXNlVHJhbnNsYXRpb24oJ3RyYW5zbGF0aW9uJywge1xuICAgIGtleVByZWZpeDogJ1JlbW90ZURlc2t0b3BFeGVyY2lzZScsXG4gIH0pO1xuICByZXR1cm4gKFxuICAgIDxCdXR0b25cbiAgICAgIGFwcGVhcmFuY2U9XCJkZWZhdWx0XCJcbiAgICAgIGNzcz17Y3NzYFxuICAgICAgICB3aWR0aDogOTBweDtcbiAgICAgIGB9XG4gICAgICBkYXRhQXR0cmlidXRlcz17e1xuICAgICAgICBjeTogZGF0YUxhYmVsLFxuICAgICAgfX1cbiAgICAgIGludGVudD1cIm5ldXRyYWxcIlxuICAgICAgb25DbGljaz17b25DbGlja31cbiAgICAgIHNpemU9XCJzbWFsbFwiXG4gICAgPlxuICAgICAge3QoJ0NvbnZlcnNhdGlvbmFsSW50ZXJmYWNlTGF5b3V0LmhpbnQnKSBhcyBzdHJpbmd9XG4gICAgPC9CdXR0b24+XG4gICk7XG59O1xuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
export const HintButton = _ref2 => {
  let {
    dataLabel,
    onClick
  } = _ref2;
  const {
    t
  } = useTranslation('translation', {
    keyPrefix: 'RemoteDesktopExercise'
  });
  return jsx(Button, {
    appearance: "default",
    css: _ref,
    dataAttributes: {
      cy: dataLabel
    },
    intent: "neutral",
    onClick: onClick,
    size: "small"
  }, t('ConversationalInterfaceLayout.hint'));
};